export default {
  stripe:
    process.env.REACT_APP_ENV === 'dev'
      ? process.env.REACT_APP_STRIPE_DEV_KEY
      : process.env.REACT_APP_STRIPE_PROD_KEY,
  plaidPublicKey: process.env.REACT_APP_PLAID_PUBLIC_KEY,
};
